webpackJsonp([1],{

/***/ "/7yB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SwatchCard',
  props: {
    id: Number,
    articles: Object,
    swatches: Object,
    inspirationBoard: Array
  },
  computed: {
    data: function data() {
      return this.swatches['id' + this.id];
    },
    onInspirationBoard: function onInspirationBoard() {
      return this.inspirationBoard.indexOf(this.id) >= 0;
    }
  },
  methods: {
    showSwatchDetail: function showSwatchDetail() {
      this.$emit('show-swatch-detail', this.id);
    },
    removeSwatchFromInspirationBoard: function removeSwatchFromInspirationBoard() {
      this.$emit('remove-swatch-from-inspiration-board', this.id);
    },
    setSlideoutArticle: function setSlideoutArticle() {
      this.$emit('set-slideout-article', this.data.article);
    }
  }
});

/***/ }),

/***/ "1BWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SwatchCard__ = __webpack_require__("RFcw");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InspirationBoard',
  components: {
    SwatchCard: __WEBPACK_IMPORTED_MODULE_1__components_SwatchCard__["a" /* default */]
  },
  props: {
    articles: Object,
    swatches: Object,
    inspirationBoard: Array
  },
  data: function data() {
    return {
      showPermalink: false,
      modalShareOpen: false,
      shareEmail: '',
      shareMessage: '',
      errorLoading: false,
      errorValidating: false
    };
  },

  computed: {
    local: function local() {
      return this.$route.params.target === 'local';
    },
    swatchIds: function swatchIds() {
      var _this = this;

      var retval = [];
      if (this.local) {
        retval = this.inspirationBoard;
      } else {
        this.$route.params.target.split('-').forEach(function (element) {
          if (_this.isInt(element)) {
            if (retval.indexOf(element) < 0) {
              retval.push(parseInt(element, 10));
            }
          }
        });
      }
      return retval;
    },
    title: function title() {
      return (this.local ? 'Your' : 'Shared') + ' Inspiration Board';
    },
    permalink: function permalink() {
      var ids = this.swatchIds.join('-');
      return window.location.protocol + '//' + window.location.hostname + window.location.pathname + '#/inspiration-board/' + ids;
    }
  },
  created: function created() {
    var _this2 = this;

    this.$parent.$on('view-swatches', function (articleId) {
      _this2.$router.push('/article=' + articleId);
    });
  },

  methods: {
    isInt: function isInt(n) {
      var nFloat = parseFloat(n);
      var nInt = parseInt(n, 10);
      return !isNaN(parseFloat(n)) && isFinite(n) && nFloat === nInt;
    },
    showSwatchDetail: function showSwatchDetail(id) {
      this.$emit('show-swatch-detail', id); // pass it up the chain
    },
    removeSwatchFromInspirationBoard: function removeSwatchFromInspirationBoard(id) {
      this.$emit('remove-swatch-from-inspiration-board', id); // pass it up the chain
    },
    loadToBoard: function loadToBoard() {
      this.$emit('load-inspiration-board', this.swatchIds); // pass it up the chain
    },
    clearBoard: function clearBoard() {
      this.$emit('clear-inspiration-board'); // pass it up the chain
      this.showPermalink = false;
    },
    requestSamples: function requestSamples() {
      var swatchIdString = '';
      this.swatchIds.forEach(function (swatchId) {
        swatchIdString = swatchIdString + '&sample_swatch_id[]=' + swatchId;
      });
      window.location.assign('/request-samples?request=true' + swatchIdString);
    },
    sendMessage: function sendMessage() {
      var _this3 = this;

      if (!this.shareEmail.length) {
        this.errorValidating = true;
      } else {
        this.errorValidating = false;
        var requestData = {
          email: this.shareEmail,
          message: this.shareMessage,
          permalink: this.permalink
        };
        var request = new XMLHttpRequest();
        request.open('POST', '/api/send-inspiration-board', true);
        request.setRequestHeader('Content-type', 'application/json');
        request.onload = function () {
          if (request.status >= 200 && request.status < 400) {
            // Success!
            var result = JSON.parse(request.responseText);
            if (result.status === 'Success') {
              _this3.modalShareOpen = false;
            } else {
              _this3.errorLoading = true;
            }
          } else {
            // We reached our target server, but it returned an error
            _this3.errorLoading = true;
          }
        };
        request.onerror = function () {
          // There was a connection error of some sort
          _this3.errorLoading = true;
        };
        request.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(requestData));
      }
    },
    setSlideoutArticle: function setSlideoutArticle(slideoutArticleId) {
      this.$emit('set-slideout-article', slideoutArticleId);
    }
  }
});

/***/ }),

/***/ "1U14":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"card-article-swatch card-article col-sm-3",attrs:{"data-id":_vm.id}},[_c('div',{staticClass:"card-thumbnail",style:({ backgroundImage: 'url(' + _vm.data.thumbnail + ')' }),on:{"click":function($event){$event.preventDefault();return _vm.$emit('filter-on', 'article', _vm.id)}}}),_vm._v(" "),_c('div',{staticClass:"card-article-name-line"},[_vm._v("\n    "+_vm._s(_vm.data.name)+" "),_c('a',{staticClass:"info",on:{"click":function($event){return _vm.setSlideoutArticle()}}})]),_vm._v(" "),_c('div',{staticClass:"card-swatch-name-line"},[_vm._v(" ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2wHT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleSlideout_vue__ = __webpack_require__("WiMR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29e2b230_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleSlideout_vue__ = __webpack_require__("P2We");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleSlideout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29e2b230_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleSlideout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "59Hn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ArticleCard__ = __webpack_require__("qpnX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FilterDisplay__ = __webpack_require__("Vilo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SwatchCard__ = __webpack_require__("RFcw");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductBrowser',
  components: {
    ArticleCard: __WEBPACK_IMPORTED_MODULE_1__components_ArticleCard__["a" /* default */],
    FilterDisplay: __WEBPACK_IMPORTED_MODULE_2__components_FilterDisplay__["a" /* default */],
    SwatchCard: __WEBPACK_IMPORTED_MODULE_3__components_SwatchCard__["a" /* default */]
  },
  props: {
    articles: Object,
    swatches: Object,
    inspirationBoard: Array,
    filterOptions: Object
  },
  data: function data() {
    return {
      filtersApplied: []
    };
  },

  computed: {
    viewType: function viewType() {
      var retval = 'Article';
      this.filtersApplied.forEach(function (filter) {
        if (filter.type.localeCompare('article') === 0 || filter.type.localeCompare('color') === 0 || filter.type.localeCompare('look') === 0) {
          retval = 'Swatch';
        }
      });
      return retval;
    },
    visibleCards: function visibleCards() {
      var _this = this;

      var retval = this.articles;
      if (this.filtersApplied.length) {
        if (this.viewType.localeCompare('Article') === 0) {
          retval = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.articles).filter(function (item) {
            var visible = true;
            _this.filtersApplied.every(function (filter) {
              var thisVisible = false;
              switch (filter.type) {
                case 'origin':
                  {
                    for (var j = 0; j < item.origin.length; j += 1) {
                      if (parseInt(item.origin[j].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'level_of_protection':
                  {
                    for (var _j = 0; _j < item.levelOfProtection.length; _j += 1) {
                      if (parseInt(item.levelOfProtection[_j].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'thickness':
                  {
                    for (var _j2 = 0; _j2 < item.thickness.length; _j2 += 1) {
                      if (parseInt(item.thickness[_j2].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'enhanced_spec':
                  {
                    for (var _j3 = 0; _j3 < item.enhancedSpec.length; _j3 += 1) {
                      if (parseInt(item.enhancedSpec[_j3].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'average_hide_size':
                  {
                    for (var _j4 = 0; _j4 < item.averageHideSize.length; _j4 += 1) {
                      if (parseInt(item.averageHideSize[_j4].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'price_tier':
                  {
                    for (var _j5 = 0; _j5 < item.priceTier.length; _j5 += 1) {
                      if (parseInt(item.priceTier[_j5].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'application':
                  {
                    for (var _j6 = 0; _j6 < item.application.length; _j6 += 1) {
                      if (parseInt(item.application[_j6].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                default:
              }
              if (!thisVisible) {
                visible = false;
                return false;
              }
              return true;
            });
            return visible;
          });
        } else {
          retval = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.swatches).filter(function (item) {
            var visible = true;
            _this.filtersApplied.every(function (filter) {
              var thisVisible = false;
              switch (filter.type) {
                case 'article':
                  {
                    if (parseInt(item.article, 10) === parseInt(filter.id, 10)) {
                      thisVisible = true;
                    }
                    break;
                  }
                case 'color':
                  {
                    for (var j = 0; j < item.color.length; j += 1) {
                      if (parseInt(item.color[j].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'look':
                  {
                    for (var _j7 = 0; _j7 < item.look.length; _j7 += 1) {
                      if (parseInt(item.look[_j7].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'origin':
                  {
                    var origins = _this.articles['id' + item.article].origin;
                    for (var _j8 = 0; _j8 < origins.length; _j8 += 1) {
                      if (parseInt(origins[_j8].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'level_of_protection':
                  {
                    var levelOfProtections = _this.articles['id' + item.article].levelOfProtection;
                    for (var _j9 = 0; _j9 < levelOfProtections.length; _j9 += 1) {
                      if (parseInt(levelOfProtections[_j9].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'thickness':
                  {
                    var thicknesss = _this.articles['id' + item.article].thickness;
                    for (var _j10 = 0; _j10 < thicknesss.length; _j10 += 1) {
                      if (parseInt(thicknesss[_j10].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'enhanced_spec':
                  {
                    var enhancedSpecs = _this.articles['id' + item.article].enhancedSpec;
                    for (var _j11 = 0; _j11 < enhancedSpecs.length; _j11 += 1) {
                      if (parseInt(enhancedSpecs[_j11].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'average_hide_size':
                  {
                    var averageHideSizes = _this.articles['id' + item.article].averageHideSize;
                    for (var _j12 = 0; _j12 < averageHideSizes.length; _j12 += 1) {
                      if (parseInt(averageHideSizes[_j12].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'price_tier':
                  {
                    var priceTiers = _this.articles['id' + item.article].priceTier;
                    for (var _j13 = 0; _j13 < priceTiers.length; _j13 += 1) {
                      if (parseInt(priceTiers[_j13].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                case 'application':
                  {
                    var applications = _this.articles['id' + item.article].application;
                    for (var _j14 = 0; _j14 < applications.length; _j14 += 1) {
                      if (parseInt(applications[_j14].id, 10) === parseInt(filter.id, 10)) {
                        thisVisible = true;
                        break;
                      }
                    }
                    break;
                  }
                default:
              }
              if (!thisVisible) {
                visible = false;
                return false;
              }
              return true;
            });
            return visible;
          });
        }
      }
      return retval;
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.filterOptions) {
      this.$emit('load-filter-options');
    }
    if (this.$route.params[0].length) {
      var filterRequests = this.$route.params[0].split('&');
      filterRequests.forEach(function (filterRequest) {
        var pair = filterRequest.split('=');
        if (pair.length === 2) {
          _this2.filterOn(pair[0], pair[1]);
        }
      });
      this.$router.replace('/');
    }
    this.$parent.$on('view-swatches', function (articleId) {
      _this2.filtersApplied = [{ type: 'article', id: articleId }];
    });
  },

  methods: {
    clearFilters: function clearFilters() {
      this.filtersApplied.splice(0, this.filtersApplied.length);
    },
    filterOn: function filterOn(type, id) {
      if (parseInt(id, 10) > 0) {
        this.filtersApplied.push({ type: type, id: id });
        document.getElementById('app').scrollIntoView(true);
      }
    },
    removeSwatchFromInspirationBoard: function removeSwatchFromInspirationBoard(id) {
      this.$emit('remove-swatch-from-inspiration-board', id); // pass it up the chain
    },
    setSlideoutArticle: function setSlideoutArticle(slideoutArticleId) {
      this.$emit('set-slideout-article', slideoutArticleId); // pass it up the chain
    },
    showSwatchDetail: function showSwatchDetail(id) {
      this.$emit('show-swatch-detail', id); // pass it up the chain
    },
    unapplyFilter: function unapplyFilter(filter) {
      var filterIndex = this.filtersApplied.indexOf(filter);
      if (filterIndex >= 0) {
        this.filtersApplied.splice(filterIndex, 1);
      }
    }
  }
});

/***/ }),

/***/ "Ii32":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filterOptions)?_c('div',{staticClass:"product-browser"},[_c('filter-display',{attrs:{"articles":_vm.articles,"filter-options":_vm.filterOptions,"filters-applied":_vm.filtersApplied},on:{"clear-filters":_vm.clearFilters,"filter-on":_vm.filterOn,"unapply-filter":_vm.unapplyFilter}}),_vm._v(" "),_c('div',{staticClass:"product-browser-browser"},_vm._l((_vm.visibleCards),function(card){return _c((_vm.viewType + "Card"),{tag:"component",attrs:{"id":card.id,"articles":_vm.articles,"swatches":_vm.swatches,"inspiration-board":_vm.inspirationBoard},on:{"filter-on":_vm.filterOn,"show-swatch-detail":_vm.showSwatchDetail,"remove-swatch-from-inspiration-board":_vm.removeSwatchFromInspirationBoard,"set-slideout-article":_vm.setSlideoutArticle}})}),1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Klxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"card-article-swatch card-swatch col-sm-4 col-md-3",attrs:{"data-id":_vm.id}},[_c('div',{staticClass:"card-thumbnail"},[_c('div',{staticClass:"image",style:({ backgroundImage: 'url(' + _vm.data.thumbnail + ')' }),on:{"click":function($event){$event.preventDefault();return _vm.showSwatchDetail($event)}}}),_vm._v(" "),(_vm.onInspirationBoard)?_c('a',{attrs:{"href":"#remove-from-board"},on:{"click":function($event){$event.preventDefault();return _vm.removeSwatchFromInspirationBoard($event)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-article-name-line"},[_vm._v("\n    "+_vm._s(_vm.articles[("id" + (_vm.data.article))].name)+" "),_c('a',{staticClass:"info",on:{"click":function($event){return _vm.setSlideoutArticle()}}})]),_vm._v(" "),_c('div',{staticClass:"card-swatch-name-line"},[_vm._v(_vm._s(_vm.data.name))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92876e76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("TB2k");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92876e76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ArticleSlideout__ = __webpack_require__("2wHT");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('article-slideout', __WEBPACK_IMPORTED_MODULE_3__components_ArticleSlideout__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "P2We":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-slideout",class:{ 'is-active': _vm.data }},[_c('a',{staticClass:"btn-close",attrs:{"title":"Close"},on:{"click":_vm.closeArticleSlideout}}),_vm._v(" "),_c('div',{staticClass:"content"},[(!_vm.data && !_vm.errorLoading)?_c('p',[_vm._v("Loading...")]):_vm._e(),_vm._v(" "),(_vm.errorLoading)?_c('p',[_vm._v("Unable to retrieve article information")]):_vm._e(),_vm._v(" "),(_vm.data)?_c('div',[_c('h3',[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" "),_c('p',[_vm._v("\n      Raw Material: "+_vm._s(_vm.data.rawMaterial)+"\n      "),_c('br'),_vm._v("\n      Average Hide Size: "),_vm._l((_vm.data.averageHideSize),function(hideSize,index){return _c('span',[_vm._v(_vm._s(hideSize.name)),(index != (_vm.data.averageHideSize.length - 1))?_c('span',[_vm._v(",")]):_vm._e()])})],2),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}}),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":_vm.data.thumbnail}})]),_vm._v(" "),_c('p',{staticClass:"btn-wrap"},[_c('a',{attrs:{"href":"#view-swatches","title":"View Swatches"},on:{"click":function($event){$event.preventDefault();return _vm.viewSwatches($event)}}},[_vm._v("View Swatches")])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RFcw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SwatchCard_vue__ = __webpack_require__("/7yB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe6189b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SwatchCard_vue__ = __webpack_require__("Klxk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SwatchCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe6189b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SwatchCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TB2k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.errorLoading && !_vm.articles)?_c('div',[_vm._v("\n    Loading...\n  ")]):_vm._e(),_vm._v(" "),(_vm.errorLoading)?_c('div',[_vm._v("\n    Unable to retrieve product information, please try again later.\n  ")]):_vm._e(),_vm._v(" "),(!_vm.errorLoading && _vm.articles)?_c('div',[_c('router-view',{attrs:{"articles":_vm.articles,"swatches":_vm.swatches,"inspiration-board":_vm.inspirationBoard,"filter-options":_vm.filterOptions},on:{"load-filter-options":_vm.loadFilterOptions,"show-swatch-detail":_vm.showSwatchDetail,"remove-swatch-from-inspiration-board":_vm.removeSwatchFromInspirationBoard,"load-inspiration-board":_vm.loadInspirationBoard,"clear-inspiration-board":_vm.clearInspirationBoard,"set-slideout-article":_vm.setSlideoutArticle,"set-filter-options":_vm.setFilterOptions}}),_vm._v(" "),_c('div',{staticClass:"modal modal-swatch",class:{ 'is-active': _vm.modalSwatchOpen }},[_c('div',{staticClass:"modal-card"},[_c('header',[_c('div',[_c('a',{attrs:{"href":"#close-modal","aria-label":"close"},on:{"click":function($event){$event.preventDefault();return _vm.closeSwatchModal($event)}}},[_vm._v("X close")])])]),_vm._v(" "),(!_vm.modalSwatchError && !_vm.modalSwatchData)?_c('section',{staticClass:"modal-card-body"},[_c('p',[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),(_vm.modalSwatchError)?_c('section',{staticClass:"modal-card-body"},[_c('p',[_vm._v("Unable to retrieve swatch information")])]):_vm._e(),_vm._v(" "),(_vm.modalSwatchData)?_c('section',{staticClass:"modal-card-body"},[_c('div',[_c('img',{staticClass:"modal-swatch-image",attrs:{"src":_vm.modalSwatchData.image}})]),_vm._v(" "),_c('button',{staticClass:"modal-swatch-button-toggle",on:{"click":function($event){$event.preventDefault();return _vm.toggleModalSwatchOnInspirationBoard()}}},[_vm._v("\n            "+_vm._s(_vm.modalSwatchOnInspirationBoard ? 'Remove from' : 'Add to')+" my samples")]),_vm._v(" "),_c('div',{staticClass:"modal-swatch-article-name-line"},[_vm._v(_vm._s(_vm.modalSwatchData.article.name))]),_vm._v(" "),_c('div',{staticClass:"modal-swatch-swatch-name-line"},[_vm._v(_vm._s(_vm.modalSwatchData.name))])]):_vm._e()])]),_vm._v(" "),_c('article-slideout',{attrs:{"articles":_vm.articles,"slideout-article-id":_vm.slideoutArticleId},on:{"close":_vm.clearSlideoutArticle,"set-slideout-article":_vm.setSlideoutArticle}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uf9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InspirationBoard_vue__ = __webpack_require__("1BWO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42774743_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InspirationBoard_vue__ = __webpack_require__("sD/O");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InspirationBoard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42774743_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InspirationBoard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vilo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterDisplay_vue__ = __webpack_require__("uzuL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06dd3250_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterDisplay_vue__ = __webpack_require__("i3ka");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterDisplay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06dd3250_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterDisplay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WiMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ArticleSlideout',
  props: {
    slideoutArticleId: Number,
    articles: Object
  },
  computed: {
    data: function data() {
      return this.articles['id' + this.slideoutArticleId];
    }
  },
  methods: {
    closeArticleSlideout: function closeArticleSlideout() {
      this.$emit('close');
    },
    viewSwatches: function viewSwatches() {
      this.closeArticleSlideout();
      this.$parent.$emit('view-swatches', this.slideoutArticleId);
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProductBrowser__ = __webpack_require__("jLY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_InspirationBoard__ = __webpack_require__("Uf9E");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/inspiration-board/:target',
    name: 'InspirationBoard',
    component: __WEBPACK_IMPORTED_MODULE_3__components_InspirationBoard__["a" /* default */]
  }, {
    path: '/inspiration-board',
    name: 'InspirationBoard',
    component: __WEBPACK_IMPORTED_MODULE_3__components_InspirationBoard__["a" /* default */]
  }, {
    path: '/*',
    name: 'ProductBrowser',
    component: __WEBPACK_IMPORTED_MODULE_2__components_ProductBrowser__["a" /* default */]
  }]
}));

/***/ }),

/***/ "bY88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SwatchCard',
  props: {
    id: Number,
    articles: Object
  },
  computed: {
    data: function data() {
      return this.articles['id' + this.id];
    },
    onInspirationBoard: function onInspirationBoard() {
      return this.inspirationBoard.indexOf(this.id) >= 0;
    }
  },
  methods: {
    showSwatchDetail: function showSwatchDetail() {
      this.$emit('show-swatch-detail', this.id);
    },
    setSlideoutArticle: function setSlideoutArticle() {
      this.$emit('set-slideout-article', this.id);
    }
  }
});

/***/ }),

/***/ "i3ka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-browser-filters"},[_vm._v("\n  Filter:\n  "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersApplied.length < 1),expression:"filtersApplied.length < 1"}],staticClass:"product-browser-filter"},[_vm._v("All Products")]),_vm._v(" "),_vm._l((_vm.filtersApplied),function(filter){return _c('span',{staticClass:"product-browser-filter"},[_c('span',{staticClass:"filter-name"},[_vm._v(_vm._s(_vm.formatText(filter.type)))]),_vm._v(":\n    "),_c('span',{staticClass:"filter-value"},[_vm._v(_vm._s(_vm.getFilterDisplay(filter.type, filter.id)))]),_vm._v(" "),_c('span',{staticClass:"filter-clear",on:{"click":function($event){return _vm.$emit('unapply-filter', filter)}}})])}),_vm._v(" "),_c('button',{staticClass:"product-browser-filter-button",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addFilter($event)}}},[_vm._v("\n    Add Filter\n  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersApplied.length > 0),expression:"filtersApplied.length > 0"}],staticClass:"product-browser-filter-button",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('clear-filters')}}},[_vm._v("\n    Clear Filters\n  ")]),_vm._v(" "),_c('div',{staticClass:"modal modal-filter",class:{ 'is-active': _vm.modalFilterOpen }},[_c('div',{staticClass:"modal-card"},[_c('header',[_c('div',[_c('a',{attrs:{"href":"#close-modal","aria-label":"close"},on:{"click":function($event){$event.preventDefault();return _vm.closeFilterModal($event)}}},[_vm._v("X close")])])]),_vm._v(" "),(_vm.filterOptions)?_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"filterType"}},[_vm._v("Filter By")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterTypeSelected),expression:"filterTypeSelected"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterTypeSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.filterOptions),function(item,index){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(_vm.formatText(index)))])}),0)]),_vm._v(" "),_vm._l((_vm.filterOptions),function(optionsArray,index){return (_vm.filterTypeSelected == index)?_c('div',{staticClass:"form-group radio-buttons"},_vm._l((optionsArray),function(optionName,optionId){return _c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterValueSelected),expression:"filterValueSelected"}],key:optionId,attrs:{"type":"radio"},domProps:{"value":optionId,"checked":_vm._q(_vm.filterValueSelected,optionId)},on:{"click":function($event){return _vm.addFilterValue(optionId)},"change":function($event){_vm.filterValueSelected=optionId}}}),_vm._v("\n            "+_vm._s(optionName)+"\n          ")])}),0):_vm._e()})],2):_vm._e()])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jLY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductBrowser_vue__ = __webpack_require__("59Hn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49cba74d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductBrowser_vue__ = __webpack_require__("Ii32");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductBrowser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49cba74d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductBrowser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qpnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleCard_vue__ = __webpack_require__("bY88");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b6e15a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleCard_vue__ = __webpack_require__("1U14");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b6e15a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sD/O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inspiration-board"},[(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"board-actions"},[(!_vm.local)?_c('button',{on:{"click":_vm.loadToBoard}},[_vm._v("Load to board")]):_vm._e(),_vm._v(" "),(_vm.local && _vm.swatchIds.length > 0)?_c('button',{on:{"click":_vm.clearBoard}},[_vm._v("Clear Board")]):_vm._e(),_vm._v(" "),(_vm.local && _vm.swatchIds.length > 0)?_c('button',{on:{"click":function($event){_vm.showPermalink = true}}},[_vm._v("Save Board")]):_vm._e(),_vm._v(" "),(_vm.local && _vm.swatchIds.length > 0)?_c('button',{on:{"click":function($event){_vm.modalShareOpen=true}}},[_vm._v("Share Board")]):_vm._e(),_vm._v(" "),(_vm.local && _vm.swatchIds.length > 0)?_c('button',{on:{"click":_vm.requestSamples}},[_vm._v("Request Samples")]):_vm._e()]),_vm._v(" "),(_vm.showPermalink)?_c('div',{staticClass:"board-link"},[_vm._v("\n    This board can be viewed at the following URL. Save the URL for future reference or to share.\n    "),_c('input',{staticClass:"form-control ccm-input-text",domProps:{"value":_vm.permalink}})]):_vm._e(),_vm._v(" "),(_vm.swatchIds.length == 0)?_c('p',[_vm._v("No swatches found - "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("browse our products")])],1):_vm._e(),_vm._v(" "),(_vm.swatchIds.length > 0)?_c('div',{staticClass:"card-container row"},_vm._l((_vm.swatchIds),function(id){return _c('swatch-card',{attrs:{"id":id,"articles":_vm.articles,"swatches":_vm.swatches,"inspiration-board":_vm.inspirationBoard},on:{"show-swatch-detail":_vm.showSwatchDetail,"remove-swatch-from-inspiration-board":_vm.removeSwatchFromInspirationBoard,"set-slideout-article":_vm.setSlideoutArticle}})}),1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal modal-share",class:{ 'is-active': _vm.modalShareOpen }},[_c('div',{staticClass:"modal-card"},[_c('header',[_c('div',[_c('a',{attrs:{"href":"#close-modal","aria-label":"close"},on:{"click":function($event){$event.preventDefault();_vm.modalShareOpen=false}}},[_vm._v("X close")])])]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('h2',[_vm._v("Share Inspiration Board")]),_vm._v(" "),(_vm.errorLoading)?_c('p',{staticClass:"error small"},[_vm._v("Error Sending Message")]):_vm._e(),_vm._v(" "),(_vm.errorValidating)?_c('p',{staticClass:"error small"},[_vm._v("Recipient Email is Required")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Recipient Email")]),_vm._v(" "),_c('span',{staticClass:"text-muted small"},[_vm._v("Required")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.shareEmail),expression:"shareEmail"}],staticClass:"form-control ccm-input-text",attrs:{"type":"email","name":"email","autofocus":""},domProps:{"value":(_vm.shareEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.shareEmail=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"message"}},[_vm._v("Message")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.shareMessage),expression:"shareMessage"}],staticClass:"form-control ccm-input-textarea",attrs:{"name":"message"},domProps:{"value":(_vm.shareMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.shareMessage=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{on:{"click":_vm.sendMessage}},[_vm._v("Send")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uzuL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FilterDisplay',
  props: {
    articles: Object,
    modalFilterOpen: false,
    filterOptions: Object,
    filtersApplied: Array,
    filterTypeSelected: null,
    filterValueSelected: null
  },
  methods: {
    addFilter: function addFilter() {
      this.modalFilterOpen = true;
    },
    addFilterValue: function addFilterValue(optionSelected) {
      this.filterValueSelected = optionSelected;
      this.$emit('filter-on', this.filterTypeSelected, this.filterValueSelected);
      this.closeFilterModal();
    },
    closeFilterModal: function closeFilterModal() {
      this.modalFilterOpen = false;
      this.filterTypeSelected = null;
      this.filterValueSelected = null;
    },
    formatText: function formatText(string) {
      return string.replace(/_/g, ' ');
    },
    getFilterDisplay: function getFilterDisplay(filterName, valueId) {
      switch (filterName) {
        case 'article':
          return this.articles['id' + valueId].name;
        default:
          return this.filterOptions[filterName][valueId];
      }
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      errorLoading: false,
      articles: null,
      swatches: null,
      inspirationBoard: null,
      filterOptions: null,
      modalSwatchOpen: false,
      modalSwatchId: 0,
      modalSwatchData: null,
      modalSwatchError: false,
      slideoutArticleId: null
    };
  },

  computed: {
    modalSwatchOnInspirationBoard: function modalSwatchOnInspirationBoard() {
      return this.inspirationBoard.indexOf(this.modalSwatchId) >= 0;
    }
  },
  created: function created() {
    var _this = this;

    var request = new XMLHttpRequest();
    request.open('POST', '/api/get-product-data', true);
    request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        // Success!
        var result = JSON.parse(request.responseText);
        if (result.articles && result.swatches) {
          _this.articles = result.articles;
          _this.swatches = result.swatches;
        } else {
          _this.errorLoading = true;
        }
      } else {
        // We reached our target server, but it returned an error
        _this.errorLoading = true;
      }
    };
    request.onerror = function () {
      // There was a connection error of some sort
      _this.errorLoading = true;
    };
    request.send('type=everything');

    this.inspirationBoard = JSON.parse(localStorage.getItem('inspirationBoard'));
    if (!Array.isArray(this.inspirationBoard)) {
      this.inspirationBoard = [];
    }
  },

  methods: {
    addSwatchToInspirationBoard: function addSwatchToInspirationBoard(id) {
      var swatchIds = JSON.parse(localStorage.getItem('inspirationBoard')); // ensure we're up-to-date
      if (!Array.isArray(swatchIds)) {
        swatchIds = [];
      }
      if (swatchIds.indexOf(id) === -1) {
        swatchIds.push(id);
        localStorage.setItem('inspirationBoard', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(swatchIds));
      }
      this.inspirationBoard = swatchIds;
    },
    closeSwatchModal: function closeSwatchModal() {
      this.modalSwatchOpen = false;
    },
    loadFilterOptions: function loadFilterOptions() {
      var _this2 = this;

      var request = new XMLHttpRequest();
      request.open('GET', '/api/get-filter-data', true);
      request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          var result = JSON.parse(request.responseText);
          if (result.filters) {
            _this2.filterOptions = result.filters;
          } else {
            _this2.errorLoading = true;
          }
        } else {
          // We reached our target server, but it returned an error
          _this2.errorLoading = true;
        }
      };
      request.onerror = function () {
        // There was a connection error of some sort
        _this2.errorLoading = true;
      };
      request.send();
    },
    removeSwatchFromInspirationBoard: function removeSwatchFromInspirationBoard(id) {
      var swatchIds = JSON.parse(localStorage.getItem('inspirationBoard')); // ensure we're up-to-date
      if (!Array.isArray(swatchIds)) {
        swatchIds = this.swatchIds;
      }
      var idIndex = swatchIds.indexOf(id);
      if (idIndex >= 0) {
        swatchIds.splice(idIndex, 1);
        localStorage.setItem('inspirationBoard', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(swatchIds));
      }
      this.inspirationBoard = swatchIds;
    },
    showSwatchDetail: function showSwatchDetail(id) {
      var _this3 = this;

      this.modalSwatchData = null;
      this.modalSwatchError = false;
      this.modalSwatchId = id;
      this.modalSwatchOpen = true;
      var request = new XMLHttpRequest();
      request.open('POST', '/api/get-product-data', true);
      request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          var result = JSON.parse(request.responseText);
          if (result.id == _this3.modalSwatchId) {
            // eslint-disable-line eqeqeq
            _this3.modalSwatchData = result;
          } else {
            _this3.modalSwatchError = true;
          }
        } else {
          // We reached our target server, but it returned an error
          _this3.modalSwatchError = true;
        }
      };
      request.onerror = function () {
        // There was a connection error of some sort
        _this3.modalSwatchError = true;
      };
      request.send('type=swatch&id=' + this.modalSwatchId);
    },
    toggleModalSwatchOnInspirationBoard: function toggleModalSwatchOnInspirationBoard() {
      return this.modalSwatchOnInspirationBoard ? this.removeSwatchFromInspirationBoard(this.modalSwatchData.id) : this.addSwatchToInspirationBoard(this.modalSwatchData.id);
    },
    loadInspirationBoard: function loadInspirationBoard(swatchIds) {
      this.inspirationBoard = swatchIds;
      localStorage.setItem('inspirationBoard', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(swatchIds));
      this.$router.push('/inspiration-board/local');
    },
    clearInspirationBoard: function clearInspirationBoard() {
      this.inspirationBoard = [];
      localStorage.setItem('inspirationBoard', '[]');
    },
    setSlideoutArticle: function setSlideoutArticle(slideoutArticleId) {
      this.slideoutArticleId = slideoutArticleId;
    },
    clearSlideoutArticle: function clearSlideoutArticle() {
      this.slideoutArticleId = null;
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// generated/js/app.js